import { render, staticRenderFns } from "./WhatsAppHelp.vue?vue&type=template&id=74caef22&scoped=true"
import script from "./WhatsAppHelp.vue?vue&type=script&lang=js"
export * from "./WhatsAppHelp.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppHelp.vue?vue&type=style&index=0&id=74caef22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74caef22",
  null
  
)

export default component.exports